<template>
  <v-container fill-height fluid>
    <v-overlay :absolute="false" :value="!iframe.loaded">
      <v-alert
        >CARREGANDO &nbsp;&nbsp;
        <v-progress-circular indeterminate></v-progress-circular
      ></v-alert>
    </v-overlay>
    <v-row justify="center">
      <v-col cols="12">
        <material-card color="primary">
          <template v-slot:header>
            <div class="px-3">
              <div v-if="miniTitle" class="mini-title">{{ miniTitle }}</div>
              <div class="title font-weight-bold mb-2">
                {{ desiredTitle }}
              </div>
              <v-breadcrumbs class="white-breadcrumbs" :items="getBread">
                <template v-slot:divider>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-breadcrumbs>
              <!--div class="category font-weight-thin">
                O painel de análise desse indicador ainda está em construção.
                Você pode verificar todos indicadores em 
                <a class="white--text" target="_blank"
                  href="https://proplan.ufms.br/indicadores-do-pdi-ppi/">
                  Indicadores do Plano de Desenvolvimento Institucional (PDI) Integrado
                  ao Projeto Pedagógico Institucional (PPI) / 2025 – 2030
                </a>
              </div-->
            </div>
          </template>
          <v-container class="pa-0 ma-0 text-center" align="center">
            <div class="d-flex align-center" :style="{ width: iframe.width + 'px', margin: '0 auto' }">
              <h1 class="mb-0 title-numeros">
                {{ tituloPdi }}
              </h1>
              <v-spacer />
              <a v-if="urlDicionario" :href="urlDicionario" target="_blank" class="dicionario">
                <v-img :src="logoDicionario" height="48" max-width="150" contain />
              </a>
            </div>
            <iframe
              :src="iframe.src"
              :width="iframe.width"
              :height="iframe.height"
              frameborder="0"
              ref="frameGrad"
              v-show="iframe.loaded"
              @load="loaded"
            ></iframe>
          </v-container>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from "../../src/store";
import axios from 'axios';
export default {
  components: {
    MaterialCard: () => import("../components/material/Card"),
    MaterialStatsCard: () => import("../components/material/StatsCard"),
  },
  data: () => ({
    logoDicionario: require("../assets/dicionario-de-dados.png"),
    tituloPdi: null,
    iframe: {
      src: "",
      loaded: false,
      height: null,
      width: "100%",
      originalWidth: 1220,
      originalHeight: 3500,
      autoResize: {
        active: true,
        timeout: 700,
        timer: null,
      },
    },
    miniTitle: null,
    bread: [
      {
        text: "Home",
        href: location.origin + (pathName ? ("/" + pathName) : ''),
      },
      {
        text: "PDI/PPI 2025-2030",
        href: location.origin + (pathName ? ("/" + pathName) : '') + '/pdi-2025-2030',
      },
      {
        text: "Painel da Meta PDI/PPI",
        active: true,
      },
    ],
    bread_home: [
      {
        text: "Home",
        href: location.origin + (pathName ? ("/" + pathName) : ''),
      },
      {
        text: "PDI/PPI 2025-2030",
        active: true,
      },
    ],
    urlDicionario: null
  }),
  computed: {
    // Computa a última parte do path atual
    lastPartOfPath() {
      // Obtenha o caminho atual da URL
      const currentPath = this.$route.path;
      // Use `split` para dividir o caminho nas barras (`/`) e pegue o último elemento
      const pathSegments = currentPath.replace(/[/]+/,'/').replace(/[/]$/,'').split("/");
      let numero = pathSegments[pathSegments.length - 1];
      numero = numero == "" || numero == "pdi-2025-2030" || numero == "pdi-2025-2030" ? "home" : numero;
      return numero;
    },
    hideIframe() {
      return this.lastPartOfPath == "home";
    },
    paramLoginLooker() {
      if (store && store.state && store.state.passaporte) {
        return '?authuser=' + store.state.passaporte + '%40ufms.br'
      }
      return '?';
    },
    getBread() {
      return this.lastPartOfPath == "home" ? this.bread_home : this.bread;
    },
    desiredPath() {
      switch (this.lastPartOfPath) {
        case "1.1": case 'pdi-taxa-sucesso-graduacao':
            return '//lookerstudio.google.com/embed/reporting/362e6e8a-1cf0-4de3-8cc6-d9b5de5307bd/page/p_fo55594ojd'+this.paramLoginLooker;
        case "1.2": case 'pdi-qualidade-cursos-de-graduacao':
            return '//metabase.ufms.br/public/dashboard/af32dd12-d26b-4bda-8617-b0b7335c42dc';
        case "1.3": case 'pdi-taxa-sucesso-pos-graduacao':
          return "https://metabase.ufms.br/public/dashboard/064a13b3-7d3c-4463-972c-01ffb57867d4";
        case "1.4": case 'pdi-qualidade-cursos-de-pos-graduacao':
          return "https://metabase.ufms.br/public/dashboard/bfac40f3-11f5-466c-861f-ef78deee1488";
        case "2.7":
          return "https://lookerstudio.google.com/embed/reporting/e3603b57-3f22-4411-b0eb-dd8df58910a8"+this.paramLoginLooker;
        case "2.8":
          return "https://lookerstudio.google.com/embed/reporting/6d0b5f33-1174-45d4-b9c6-ba66bfc27a03"+this.paramLoginLooker;
        case "2.9":
          return "https://lookerstudio.google.com/embed/reporting/8a5ebb5d-f068-437a-a716-eb491b133694"+this.paramLoginLooker;
          
        case "3.1":
          return "https://metabase.ufms.br/public/dashboard/5ac4577e-2975-4be2-a0ce-5be74e87ae78";
        case "3.2":
          return "https://metabase.ufms.br/public/dashboard/22a7d6bb-5a20-413c-9413-e5fb8bfd9229";
        case "3.3":
          return "//lookerstudio.google.com/embed/reporting/4a28a36f-4cea-46c7-af8a-09f3eefe72c9/page/Eu1XE"+this.paramLoginLooker;
        case "3.5":
          return "//lookerstudio.google.com/embed/reporting/4a0a0c8a-1dc3-46fe-ba39-c1167c3ac050/page/p_e42ytailud"+this.paramLoginLooker;
        case "3.6":
            return "//lookerstudio.google.com/embed/reporting/101cad28-f636-40f8-8b38-e1a9d1cac5f5"+this.paramLoginLooker;
        case "3.7":
            return "//lookerstudio.google.com/embed/reporting/a85726da-f4ec-4100-b3eb-336242b1e776/page/p_iez12oq4sd"+this.paramLoginLooker;
        case "4.4":
            return "//lookerstudio.google.com/embed/reporting/134f3c6a-c5a4-46b1-9cf7-add6866b0d4b"+this.paramLoginLooker;
        case "home": // home é uma visão geral do PDI
          return "//lookerstudio.google.com/embed/reporting/bd2543f5-7daf-4fd3-b7d4-f4c30560a546"+this.paramLoginLooker;
        default:
          return "https://metabase.ufms.br/public/dashboard/d2b6aac5-9423-4e27-876f-dc5cbe4671ff";
      }
      
    },
    desiredTitle() {
      let numero = this.$route.path;
      // Use `split` para dividir o caminho nas barras (`/`) e pegue o último elemento
      numero = numero.split("/");
      numero = numero[numero.length - 1];
      numero = numero == "pdi-2025-2030" ? "" : numero;
      if (['pdi-taxa-sucesso-graduacao', 'pdi-qualidade-cursos-de-graduacao',
            'pdi-taxa-sucesso-pos-graduacao', 'pdi-qualidade-cursos-de-pos-graduacao'].includes(this.lastPartOfPath)) {
        numero = '1'
      }
    
      switch (numero[0]) {
        case "1":
          return "Ensino de Graduação e de Pós-Graduação";
        case "2":
          return "Pesquisa, Extensão, Internacionalização, Inovação e Empreendedorismo";
        case "3":
          return "Cidadania, Bem-estar e Desenvolvimento Humano";
        case "4":
          return "Governança, Gestão, Sustentabilidade Ambiental e Responsabilidade Social";
        default:
          return "PDI/PPI 2025-2030";
      }
    },
  },
  mounted() {
    // Quando o componente for montado, obtenha o caminho atual da URL
    const currentPath = this.$route.path;
    this.iframe.src = this.desiredPath;
    // this.iframe.css.display = "none";
  },
  beforeDestroy() {
    if (this.iframe.autoResize.timer) {
      clearInterval(this.iframe.autoResize.timer);
    }
  },
  watch: {
    // Observe as mudanças na rota atual
    "$route.path": function(newPath, oldPath) {
      // Use `window.location.href` ou `window.location.replace` para recarregar a página
      this.iframe.loaded = false;
      setTimeout(() => {
        this.iframe.loaded = true;
      }, 1000); // delay
      this.iframe.src = this.desiredPath;
    },
  },
  methods: {
    loaded: function() {
      if (this.iframe.autoResize.active) {
        this.iFrameResize();
        this.iframe.autoResize.timer = setInterval(
          this.iFrameResize,
          this.iframe.autoResize.timeout
        );
      }
      setTimeout(() => {
        this.iframe.loaded = true;
      }, 1000); // delay
      (async function (self){
        try {
          const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/get-url`,
            {
              params: { path: self.$route.path },
              headers: { Authorization: `Bearer ${keycloak.token}` },
              timeout: 5000 // Opcional: define timeout de 5 segundos
            }
          );
          if (!response.data.ok) {
            throw new Error('Resposta do servidor não foi OK');
          }
          if (!response.data.ok) {
            throw new Error('Falha ao carregar URL do iframe');
          }
          if (response.data.title) {
            self.title = response.data.title;
          }
          self.miniTitle = null;
          if (response.data.grupo) {
            self.miniTitle = response.data.grupo;
          }
          self.urlDicionario = null;
          if (response.data.grupo) {
            self.urlDicionario = response.data.url_dicionario_dados;
          }
          self.tituloPdi = null;
          if (response.data.page_titulo) {
            self.tituloPdi = response.data.page_titulo;
          }
          if (response.data.h) {
            self.iframe.originalHeight = response.data.h;
          }
          if (response.data.w) {
            self.iframe.originalWidth = response.data.w;
          }
          if (response.data.url) {
            self.iframe.src = response.data.url;
          }
        } catch (error) {
        }
      })(this)
    },

    iFrameResize() {
      if (!this.$refs.frameGrad) {
        return;
      }
      this.iframe.height = this.iframe.originalHeight
      this.iframe.width = this.iframe.originalWidth

      //let parentWidth = this.$refs.frameGrad.parentElement.clientWidth;
      //let ratio = this.iframe.originalHeight / this.iframe.originalWidth;
      //this.iframe.height = parseInt(ratio * parentWidth) + "px";
      //this.iframe.width = "100%";
    },
  },
};
</script>

<style lang="scss">
.tim-note {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  margin-left: 20px;
  width: 260px;
}
.title-numeros{
  padding-left: 7px;
  color: #104365;
}
.dicionario{
    margin-right: 5px;
}
.mini-title {
  display: inline-block;
  color: #fff;
  font-weight: bold;
  margin-bottom: 4px;
  font-size: .8rem;
}
.white-breadcrumbs {
  a {
    color: #BDCED9 !important;
    text-decoration: underline !important;
  }
  .v-breadcrumbs__item--disabled {
    color: white !important;
    text-decoration: none !important;
  }
  .v-icon {
    color: white !important;
  }
}
.v-card {
  ul,
  ol {
    li {
      padding:0 0 0 0!important;
      font-size: 0.7em;
    }
    padding:0;
    padding-bottom: 10px;
  }
}
</style>
